import { Panel } from '../../ui/Panel';
import { Field } from '../../ui/Field';
import { ChipSelect } from '../../ui/ChipSelect';
import { PlatformIcon } from '../PlatformIcon';
import { platformMeta, platforms, statuses, suggestedTimes } from '../socialOptions';
import { inputCls } from '../../ui/styles';
import type { SocialPost } from '../../../core/types/social';
type Props = {
  post: SocialPost;
  set: (patch: Partial<SocialPost>) => void;
};

/** Status, dag, tijd en kanalen. */
export function PostPlanningPanel({
  post,
  set
}: Props) {
  return <Panel title="Planning" data-id="element-4281" data-mp="3gqr4w1nnmfl1">
      <div className="space-y-5" data-id="element-4282" data-mp="3grkedadzzj6v">
        <Field label="Status" as="div" data-id="element-4283" data-mp="3byhfqnud5jjt">
          <div role="radiogroup" aria-label="Status" className="grid grid-cols-2 gap-1.5 sm:grid-cols-4" data-id="element-4284" data-mp="3bx6eovsaypwe">
            {statuses.map(s => <button key={s.key} type="button" role="radio" aria-checked={post.status === s.key} onClick={() => set({
            status: s.key
          })} className={`rounded-md px-3 py-2.5 text-[13px] transition-colors duration-150 ease-soft ${post.status === s.key ? 'bg-ink text-shell' : 'bg-white text-ink ring-1 ring-line hover:ring-ink/30'}`} data-id="element-4285" data-mp="89nyhkwmj28f">
                {s.label}
              </button>)}
          </div>
        </Field>

        <div className="grid gap-5 sm:grid-cols-2" data-id="element-4286" data-mp="1rgvpw4b9x3zj">
          <Field label="Datum" data-id="element-4287" data-mp="1dixnzye5300x">
            <input type="date" value={post.date} onChange={e => set({
            date: e.target.value
          })} className={inputCls} data-id="element-4288" data-mp="1dhmctdid6pzs" />
          </Field>
          <Field label="Tijd" hint="Je doelgroep kijkt vooral ’s avonds en in het weekend ’s ochtends." data-id="element-4289" data-mp="14iis653ju2j6">
            <input type="time" value={post.time} onChange={e => set({
            time: e.target.value
          })} className={inputCls} data-id="element-4290" data-mp="18juikcu8yrsf" />
          </Field>
        </div>
        <div role="group" aria-label="Vaste tijden" className="-mt-2 flex flex-wrap gap-1.5 sm:justify-end" data-id="element-4291" data-mp="2yx1r5xovtnwg">
          {suggestedTimes.map(t => <button key={t} type="button" onClick={() => set({
          time: t
        })} aria-pressed={post.time === t} className={`min-h-[36px] rounded-full px-3 py-1.5 text-[12px] tabular-nums transition-colors duration-150 ease-soft ${post.time === t ? 'bg-sand text-ink ring-1 ring-ink/20' : 'text-muted ring-1 ring-line hover:text-ink'}`} data-id="element-4292" data-mp="fpfzphrtu7ru">
              {t}
            </button>)}
        </div>

        <Field label="Waar plaats je het?" as="div" data-id="element-4293" data-mp="ue2e9h9mqvi0">
          <ChipSelect options={platforms} value={post.platforms} onChange={v => set({
          platforms: v
        })} data-id="element-4294" data-mp="ugou046ochbb" />
          {post.platforms.length > 0 && <ul className="mt-3 space-y-1.5" data-id="element-4295" data-mp="kpkdv159iqew">
              {post.platforms.map(x => <li key={x} className="flex items-start gap-2 text-[12px] leading-snug text-muted" data-id="element-4296" data-mp="1i4oggrwydlk3">
                  <PlatformIcon platform={x} className="mt-px h-3.5 w-3.5 shrink-0" data-id="element-4297" data-mp="1dd6i8bmbdz2t" />
                  <span data-id="element-4298" data-mp="1koun57cybq4c">
                    <span className="text-ink" data-id="element-4299" data-mp="1kpmhyfyq5jtk">{x}:</span> {platformMeta[x].use}
                  </span>
                </li>)}
            </ul>}
        </Field>
      </div>
    </Panel>;
}